import logger from '@eventbrite/client-logger';
import { ApplePayWithMerchantIndentifier } from '../actions/applePay';

/**
 * @WARNING This will throw an error in Safari on organizer sites.
 */
export const isApplePaySupported = () => {
    try {
        return (
            window.ApplePaySession?.supportsVersion(3) &&
            window.ApplePaySession?.canMakePayments()
        );
    } catch (e) {
        logger.error(e);
        return false;
    }
};

/**
 * @WARNING This will throw an error in Safari on organizer sites.
 */
export const isApplePayCardActive = async (
    applePayInstance: ApplePayWithMerchantIndentifier,
) => {
    try {
        return (
            isApplePaySupported() &&
            (await window.ApplePaySession?.canMakePaymentsWithActiveCard(
                applePayInstance.merchantIdentifier,
            ))
        );
    } catch (e) {
        logger.error(e);
        return false;
    }
};
